import { useRef } from 'react'

/**
 * 编辑器共用的「只结算一次」钩子。
 *
 * Enter 提交、Esc 取消、失焦提交都走这里，避免 blur 与 keydown 双重提交。
 * M9.1 起从 BoardCell.tsx 抽到 cells/ 下，供各单元格组件族共享。
 */
export function useSettle(onCommit: (v: string) => void, onCancel: () => void) {
  const settled = useRef(false)
  return {
    commit: (v: string) => {
      if (settled.current) return
      settled.current = true
      onCommit(v)
    },
    cancel: () => {
      if (settled.current) return
      settled.current = true
      onCancel()
    },
  }
}
